







import Vue from 'vue'

import { Widget } from '../base'
import ReportItem from './ReportItem.vue'

export default Vue.extend({
  props: {
    widget: {
      type: Object as () => Widget,
      required: true
    }
  },
  components: {
    ReportItem
  },
  data() {
    return {
    }
  }
})
